import React, { useEffect } from 'react';
import Navbar from '@/components/homepage/Navbar';
import Footer from '@/components/homepage/Footer';
import HeroSection from '@/components/homepage/home/HeroSection';
import WhatIsSection from '@/components/homepage/home/WhatIsSection';
import WhyJoinSection from '@/components/homepage/home/WhyJoinSection';
import BrokerSection from '@/components/homepage/home/BrokerSection';
import TradersSection from '@/components/homepage/home/TradersSection';
import PerformanceSection from '@/components/homepage/home/PerformanceSection';
import HowItWorksSection from '@/components/homepage/home/HowItWorksSection';
import TeamSection from '@/components/homepage/home/TeamSection';
import GlobalPresenceSection from '@/components/homepage/home/GlobalPresenceSection';
import ReferralSection from '@/components/homepage/home/ReferralSection';
import EventsSection from '@/components/homepage/home/EventsSection';
import ConnectSection from '@/components/homepage/home/ConnectSection';
import FloatingButtons from '@/components/general/FloatingButtons';

const Home: React.FC = () => {
  useEffect(() => {
    // Smooth scroll functionality for anchor links
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a');
      
      if (!anchor || !anchor.hash) return;
      
      const element = document.querySelector(anchor.hash);
      if (element) {
        e.preventDefault();
        window.scrollTo({
          top: element.getBoundingClientRect().top + window.pageYOffset,
          behavior: 'smooth'
        });
      }
    };
    
    document.addEventListener('click', handleAnchorClick);
    
    // Initial style setup
    document.body.classList.add('bg-gray-900');
    
    return () => {
      document.removeEventListener('click', handleAnchorClick);
      document.body.classList.remove('bg-gray-900');
    };
  }, []);
  
  return (
    <div className="min-h-screen overflow-x-hidden flex flex-col bg-gray-900 text-white">
      <Navbar />
      
      <main className="flex-grow">
        <HeroSection />
        <WhatIsSection />
        <WhyJoinSection />
        <BrokerSection />
        <TradersSection />
        <PerformanceSection />
        <HowItWorksSection />
        {/* <TeamSection /> */}
        {/* <GlobalPresenceSection /> */}
        <ReferralSection />
        <EventsSection />
        <ConnectSection />
      </main>
      
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default Home;
